// app/[lang]/(dashboard)/company-certificates/_components/certificate-filter.tsx
"use client";

import ComboBoxSimple, {
    ComboBoxSimpleType,
} from "@/components/ui/combobox-simple";
import { useIsArabic } from "@/hooks/use-isArabic";
import { _t } from "@/lib/utils";
import Link from "next/link";

interface CertificateFilterProps {
  categories: string[];
  comboboxCategories: ComboBoxSimpleType[];
  activeFilter: string;
  onFilterChangeAction: (filter: string) => void;
  toSlug: (s: string) => string;
  pathname: string;
  filterParam: string | null;
  isPending: boolean;
  pendingFilter: string | null;
}

export default function CertificateFilter({
  categories,
  comboboxCategories,
  activeFilter,
  onFilterChangeAction,
  toSlug,
  pathname,
  filterParam,
  isPending,
  pendingFilter,
}: CertificateFilterProps) {
  const { lang } = useIsArabic();

  function filterHref(category: string) {
    if (category === "All") return pathname;
    return `${pathname}?filter=${toSlug(category)}`;
  }

  return (
    <div className="my-12 px-4">
      {/* Desktop: real <Link> so each filter pill is a shareable URL */}
      <div className="hidden md:flex justify-center flex-wrap gap-2">
        {categories.map((category) => {
          const isActive = activeFilter === category;
          return (
            <Link
              key={category}
              href={filterHref(category)}
              scroll={false}
              onClick={() => onFilterChangeAction(category)}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
                isActive
                  ? "bg-primary text-white"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-300"
              }`}
            >
              {isPending && pendingFilter === category && (
                <span className="inline-block h-3 w-3 rounded-full border-2 border-white border-t-transparent animate-spin" />
              )}
              {category}
            </Link>
          );
        })}
      </div>

      {/* Mobile: combobox */}
      <div className="md:hidden w-full max-w-xs mx-auto">
        <ComboBoxSimple
          items={comboboxCategories}
          label={_t("category", lang)}
          value={activeFilter}
          onChange={(item) =>
            onFilterChangeAction(item ? item.name : _t("all", lang))
          }
        />
      </div>
    </div>
  );
}
